<template>
    <v-card>
        <v-card-title class="text-h5">Gym Champs Leaderboard</v-card-title>

        <v-card-text>
            <v-row align="center" class="mx-0 mt-4">
                <v-col>
                    <v-select
                        v-model="selectedSessions"
                        :loading="loadingSessions"
                        :items="sessions.map(session => ({ text: session.title_with_time, value: session.id }))"
                        label="Sessions"
                        multiple
                    />
                </v-col>
            </v-row>

            <v-row align="center" class="mx-0 mt-4">
                <v-col>
                    <v-switch v-model="artwork" label="Show Artwork" />
                </v-col>
            </v-row>

            <v-row align="center" class="mx-0 mt-4">
                <v-col>
                    Interval (seconds)
                    <v-slider
                        v-model="interval"
                        class="align-center"
                        step="5"
                        :max="60"
                        :min="10"
                        hide-details
                        prepend-icon="mdi-clock"
                    >
                        <template #append>
                            <v-text-field v-model="interval" class="mt-0 pt-0" type="number" style="width: 60px" />
                        </template>
                    </v-slider>
                </v-col>
            </v-row>

            <v-row align="center" class="mx-0 mt-4">
                <v-col cols="4">
                    <v-text-field v-model="perPage" type="number" label="Results per page" />
                </v-col>
            </v-row>
        </v-card-text>

        <v-card-actions>
            <v-spacer />
            <v-btn color="primary" @click="present"> Present </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import find from 'lodash/find.js';
import Meet from '@/Models/Meet.js';
import Session from '@/Models/Session.js';
import backgroundColors from '@/background-colors.js';

export default {
    name: 'GymChampsMeetLeaderboardModal',

    props: {
        meet: {
            type: Meet,
            required: true,
        },
    },

    data: () => ({
        selectedSessions: [],
        loadingSessions: false,
        error: null,
        rounds: [
            { text: 'Qualification', value: 'prelims' },
            { text: 'Q2', value: 'semi_final' },
            { text: 'Finals', value: 'finals' },
            { text: 'Final One', value: 'final_one' },
            { text: 'Final Two', value: 'final_two' },
        ],
        interval: 20,
        perPage: 8,
        contrast: false,
        artwork: true,
    }),

    computed: {
        sessions() {
            return Session.query().with('flights').where('meet_id', this.meet.id).get();
        },
    },

    created() {
        this.loadSessions();
    },

    methods: {
        async loadSessions() {
            try {
                this.error = null;

                this.loadingSessions = true;

                await Session.api().get(`/api/sessions?filter[meet_id]=${this.meet.id}&include=flights`);

                this.loadingSessions = false;
            } catch (e) {
                this.error = e;
            }
        },

        present() {
            const backgroundType = this.contrast === null ? 'gradient' : 'color';

            const dark = this.contrast !== 'light' ? 'true' : 'false';

            let url = `/meets/${this.meet.id}/leaderboard/gym-champs?dark=${dark}&background_type=${backgroundType}`;

            url += `&interval=${this.interval}`;

            url += `&artwork=${this.artwork ? '1' : '0'}`;

            url += `&show_num=${this.perPage}`;

            this.selectedSessions.forEach(selectedSession => {
                const session = find(this.sessions, { id: selectedSession });

                session.flights
                    .map(flight => flight.id)
                    .forEach(flightId => {
                        url += `&flight_ids[]=${flightId}`;
                    });
            });

            if (this.contrast === 'dark') {
                url += `&background_colors[]=${encodeURIComponent('#000000,#000000')}`;
                url += '&color=ffffff';
            } else if (this.contrast === 'light') {
                url += `&background_colors[]=${encodeURIComponent('#ffffff,#ffffff')}`;
                url += '&color=000000';
            } else {
                backgroundColors.forEach(([startColor, endColor]) => {
                    url += `&background_colors[]=${encodeURIComponent(`${startColor},${endColor}`)}`;
                });
            }

            window.open(url, '_blank');
        },
    },
};
</script>
